<template>
    <v-container class="table-wrapper">
        <v-data-table
            v-model="selected"
            item-key="id"
            :headers="selectedHeaders"
            :items="items"
            :items-per-page="size"
            class="elevation-1 arraytable"
            hide-default-footer
            disable-sort
            :show-select="showSelect"
            @click:row="rowSelect"
        >
            <template v-slot:[`item.roles`]="{ item }">
                <v-chip
                    v-for="role of item.roles"
                    :key="role.id"
                    :color="getRoleColor(role.role)"
                    dark
                >
                    {{ getRoleText(role.role) }}
                </v-chip>
            </template>
            <template v-slot:[`item.sr`]="{ item }">
                <div class="sr-title">{{ item.sr }}</div>
            </template>
            <template v-slot:[`item.banned`]="{ item }">
                <v-icon v-if="item.banned" color="red">mdi-close-circle-outline</v-icon>
                <v-icon v-else color="green">mdi-check-outline</v-icon>
            </template>
            <template v-slot:[`item.status`]="{ item }">
                <assignment-status-label :status="item.status"/>
            </template>
            <template v-slot:[`item.totalQuantity`]="{ item }">
                <v-chip
                    dark
                    :color="getMaterialQuantityColor(item.totalQuantity)"
                >
                    {{ item.totalQuantity }}
                </v-chip>
            </template>
            <template v-slot:[`item.materialMeasurement`]="{ item }">
                {{ item.materialMeasurement === 'METERS' ? 'Μέτρα' : 'Τεμάχια' }}
            </template>
            <template v-slot:[`item.client`]="{ item }">
                <v-chip
                    v-if="item.client"
                    dark
                >
                    {{ item.client.name }}
                </v-chip>
            </template>
            <template v-slot:[`item.type`]="{ item }">
                {{ getTypeNames(item.type) }}
            </template>
            <template v-slot:[`item.assignmentTab`]="{ item }">
                {{ materialTabs[item.assignmentTab] }}
            </template>
            <template v-slot:[`item.priority`]="{ item }">
                <v-chip
                    v-if="item.priority"
                    dark
                    small
                    :color="priorities[item.priority]"
                >
                    {{ item.priority }}
                </v-chip>
            </template>
            <template v-slot:[`item.avatar`]="{}">
                <v-img
                    height="25px"
                    width="25px"
                    :src="require(`@/assets/profile.png`)"/>
            </template>
            <template v-slot:[`item.assignedToContractorAt`]="{ item }">
                {{ getDate(item.assignedToContractorAt )}}
            </template>
            <template v-slot:[`item.construction.appointmentDate`]="{ item }">
                {{ getDate(item.construction?.appointmentDate )}}
            </template>
            <template v-slot:[`item.taskAssignments`]="{ item }">
                {{ assigneeCount(item) }}
            </template>
            <template v-slot:[`item.coordinates`]="{ item }">
                <v-icon v-if="item.coordinates" @click="openMapOnCoordinates(item.coordinates)" :color="'#8A0000'" large>mdi-google-maps</v-icon>
            </template>
        </v-data-table>
        <custom-dialog :dialog="showDialog" @update="showDialog = !showDialog" />
        <v-pagination
            v-if="totalPages"
            v-model="localPage"
            class="pagination"
            :length="totalPages"
            total-visible="7"
            color="black"
            circle
            @input="paginationChange"
        />
        <div v-if="totalPages" class="pagination-selections">
            <v-select
                v-model="localSize"
                class="size"
                :hint="`Αντικείμενα / σελίδα: ${localSize}`"
                :items="sizes"
                persistent-hint
                return-object
                single-line
                @input="sizeChange"
            />
            <v-autocomplete
                v-model="localPage"
                class="page"
                :hint="`Μεταφορά στη σελίδα: ${localPage}`"
                :items="Array(totalPages).fill().map((v,i)=> i + 1)"
                persistent-hint
                return-object
                single-line
                @input="paginationChange"
            />
        </div>
    </v-container>
</template>

<script>
    import CustomDialog from '@/components/Dialog'
    import momentTimezone from 'moment-timezone'
    // import DeleteButton from '@/components/DeleteButton'
    import userMixin from '@/mixins/user'
    import AssignmentStatusLabel from '@/components/AssignmentStatusLabel'
    export default {
        components: { CustomDialog, AssignmentStatusLabel },
        mixins: [ userMixin ],
        props: {
            config: {
                type: Object,
                default: () => ({})
            },
            showSelect: {
                type: Boolean,
                default: () => { return false }
            },
            items: {
                type: Array,
                default: null
            },
            totals: {
                type: Object,
                default: null
            },
            headers: {
                type: Array,
                default: null
            },
            totalPages: {
                type: Number,
                default: null
            },
            page: {
                type: Number,
                default: null
            },
            size: {
                type: Number,
                default: null
            },
            type: {
                type: String,
                default: null
            },
            hideActions: {
                type: Boolean,
                default: true
            }
        },
        data: () => {
            return {
                selected: [],
                selectedHeaders: [],
                localPage: 1,
                localSize: 10,
                sizes: [5, 10, 30, 60, 100],
                role: '',
                showDialog: false,
                priorities: {
                    'A+': '#8b0000',
                    'A': '#ff0000',
                    'B': '#2596be',
                    'C': '#00b050'
                },
                actions: [
                    {
                        text: 'Επεξεργασία',
                        value: 'Edit'
                    },
                    {
                        text: 'Διαγραφή',
                        value: 'Delete'
                    }
                ],
                materialTabs: {
                    earthwork: 'Χωματουργικά',
                    blowing: 'Εμφύσηση',
                    construction: 'Κατασκευή',
                    welding: 'Κολλήσεις / Μετρήσεις',
                    oto: 'ΟΤΟ',
                    activation: 'Ενεργοποίηση'
                },
                roles: ['ROLE_ADMIN', 'ROLE_AUTOPSY', 'ROLE_EARTH_WORKER', 'ROLE_BLOWER', 'ROLE_CONSTRUCTOR_A', 'ROLE_CONSTRUCTOR_B', 'ROLE_WELDER', 'ROLE_CONTRACTOR', 'ROLE_LAST_DROP'],
                isLoading: true
            }
        },
        watch: {
            items() {
                if (Array.isArray(this.items)) {
                    this.isLoading = false
                }
            },
            headers() {
                this.selectedHeaders = this.hideActions ? this.headers : this.headers.concat(this.actions)
            },
            selected: {
                handler(newVal, oldVal) {
                    this.$emit('selectRow', newVal.map(obj => obj.id))
                },
                deep: true
            }
        },
        created() {
            this.localPage = this.page
            this.localSize = this.size
            this.selectedHeaders = this.headers
        },
        methods: {
            getMaterialQuantityColor(totalQuantity) {
                if (totalQuantity < 10) {
                    return '#8B0000'
                } else if (totalQuantity < 15) {
                    return '#F0BC68'
                }
            },
            openMapOnCoordinates(coordinates) {
                window.open(`https://www.google.com/maps?q=${coordinates.x},${coordinates.y}`, '_blank')
            },
            assigneeCount(item) {
                return new Set(item.taskAssignments.map(taskAssignment => taskAssignment.assignee.id)).size
            },
            rowSelect(item) {
                this.$emit('item-clicked', item)
            },
            getStatusText(status) {
                return this.config?.assignmentStatuses?.find(ty => ty.value === status)?.name
            },
            getStatusColor(status) {
                return this.config?.assignmentStatuses?.find(ty => ty.value === status)?.color
            },
            getTypeNames(type) {
                return this.config?.assignmentTypes?.find(ty => ty.value === type)?.name
            },
            onDelete(item, page, parent) {
                this.$emit('onDelete', item, page, parent)
            },
            handleClick(action, item) {
                this.$emit('handleClick', action, item)
            },
            paginationChange() {
                this.$emit('paginationChange', this.localPage, this.localSize)
            },
            sizeChange() {
                this.localPage = 1
                this.paginationChange()
            },
            getDate(date) {
                if (!date) {
                    return '-'
                }
                return momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            }
        }
    }
</script>

<style scoped>

    .sr-title {
        letter-spacing: 0.5px;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
    }
    .page, .size {
        max-width: 150px;
        margin-right: 1rem;
    }
    .pagination-selections {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }

    .pagination {
        padding-top: 1rem;
    }
    .arraytable {
        width: 100%;
    }
    .v-data-table {
        background: var(--cards-and-tables-color) !important;
    }
    .table-wrapper {
        width: 100% !important;
    }

</style>
<style>
    .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        color: var(--cards-and-tables-text-color) !important;
    }
    td {
        color: var(--cards-and-tables-text-color) !important;
    }
    tr {
        cursor: pointer !important;
    }
</style>
